import { render } from "./comboDetail.vue?vue&type=template&id=9144b40e&scoped=true"
import script from "./comboDetail.vue?vue&type=script&lang=js"
export * from "./comboDetail.vue?vue&type=script&lang=js"

import "./comboDetail.vue?vue&type=style&index=0&id=9144b40e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9144b40e"]])

export default __exports__